/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  deactivate(agentId) {
    return axios.put(`${this.url}/${agentId}/deactivate`);
  }

  reactivate(agentId) {
    return axios.put(`${this.url}/${agentId}/reactivate`);
  }

  // Manual unlock (admin/conv_manage_advanced). Resetea failed_attempts y
  // locked_at cuando un agente quedó bloqueado por >5 intentos fallidos
  // y no quiere esperar los 15 min del unlock_in de Devise.
  unlockAccount(agentId) {
    return axios.put(`${this.url}/${agentId}/unlock_account`);
  }
}

export default new Agents();
